import { render, staticRenderFns } from "./g-tree.vue?vue&type=template&id=1365f0b7&"
import script from "./g-tree.vue?vue&type=script&lang=js&"
export * from "./g-tree.vue?vue&type=script&lang=js&"
import style0 from "./g-tree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports